module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.numPages !== 0) ? _c('div', {
    staticClass: "search-page blue-hoki"
  }, [_c('div', {
    staticClass: "search-pagination pagination-rounded"
  }, [_c('ul', {
    staticClass: "pagination"
  }, [_c('li', {
    staticClass: "page-pre",
    class: {
      'disabled': _vm.activePage === 1
    }
  }, [_c('a', {
    staticClass: "fa fa-angle-left",
    on: {
      "click": function($event) {
        _vm.setActivePage(_vm.activePage - 1)
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "page-number",
    class: {
      'active': _vm.activePage === 1
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.setActivePage(1)
      }
    }
  }, [_vm._v("1")])]), _vm._v(" "), (_vm.activePage !== 1 && _vm.activePage !== 2 && _vm.activePage !== 3) ? _c('li', [_c('a', {
    staticClass: "pagination-ellipsis"
  }, [_vm._v(". . .")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.pagesArray), function(page, index) {
    return (_vm.showPageIndex(index)) ? _c('li', {
      staticClass: "page-number",
      class: {
        'active': _vm.activePage === page
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.setActivePage(page)
        }
      }
    }, [_vm._v(_vm._s(page))])]) : _vm._e()
  }), _vm._v(" "), (_vm.activePage !== _vm.pagesArray.length && _vm.activePage !== _vm.pagesArray.length - 1 && _vm.activePage !== _vm.pagesArray.length - 2) ? _c('li', [_c('a', {
    staticClass: "pagination-ellipsis"
  }, [_vm._v(". . .")])]) : _vm._e(), _vm._v(" "), (_vm.numPages !== 1) ? _c('li', {
    staticClass: "page-number",
    class: {
      'active': _vm.activePage === _vm.pagesArray.length
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.setActivePage(_vm.pagesArray.length)
      }
    }
  }, [_vm._v(_vm._s(_vm.pagesArray.length))])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "page-next",
    class: {
      'disabled': _vm.activePage === _vm.numPages
    }
  }, [_c('a', {
    staticClass: "fa fa-angle-right",
    on: {
      "click": function($event) {
        _vm.setActivePage(_vm.activePage + 1)
      }
    }
  })])], 2)])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0d021016!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/Pagination.vue
// module id = 404
// module chunks = 1